import React from 'react';
import { Link } from 'react-router-dom';
import SubPageHeader from '../../../components/common/SubPageHeader';
// import SubPageFooter from '../../../components/common/SubPageFooter';

const DesignWomen = () => {
  return (
    <div className="min-h-screen bg-white">
      <SubPageHeader title="DESIGN24: WOMEN" />

      <div className="py-10 md:py-20 px-4 md:px-6">
        <div className="max-w-4xl mx-auto border-4 md:border-[12px] border-[#003366] rounded-2xl md:rounded-[40px] shadow-2xl p-5 sm:p-8 md:p-16">
          <div className="space-y-4  md:space-y-6 text-[#1a1a1a]  text-[15px]  md:text-[17px] leading-7 md:leading-relaxed font-medium">
            <p className="text-lg  sm:text-xl md:text-2xl font-bold italic text-[#003366] leading-relaxed">"The STRENGTH of S - when put before HE = SHE"</p>
            <p>You Women are a blessing to this universe. You are the epitome of creativity, sacrifice and perseverance. Gratitude to YOU! You are unique.</p>
            <p>DESIGN24 course for women is to explore this uniqueness within you. Every women dreams of many things only to be sacrificed at some point of time.</p>
            <p>DESIGN24 helps you prepare your dreamlist-bucketlist and LIVE for it. This course exploits the best version of you to live a designed life. A life designed by you , designed for you, designed with you.</p>
            <p>Every person has only 24 hours to achieve his dreams or be successful in life. We help you design your every second of 24 hours.</p>
            <p>You learn the tools & techniques to gain control over emotions and maintain cordial relationship. DESIGN24 teaches you to be a placebo in your personal profession and social life.</p>
            <p>Irrespective of your age you can make a start with DESIGN24. All HAPPINESS AMBASSADORS of DESIGN 24 are living a designed HAPPY LIFE with their families and are SPREADING HAPPINESS.</p>
            <p className="font-bold uppercase tracking-widest text-[#003366]">Let us CREATE YOUR SUCCESS STORY.</p>
          </div>

          <div className="mt-12 text-center space-y-6">
            <p className="text-[#003366] font-bold text-base sm:text-lg  md:text-xl uppercase tracking-wide text-center  leading-relaxed">
              Register and book a strategic session with the master coach to live your DREAM LIFE! <br />
              JOIN THE HAPPINESS FAMILY!
            </p>
            <div className="pt-4">
              <Link to="/TGSH/login"  className="
                  inline-block
                  w-full
                  sm:w-auto
                  bg-[#003366]
                  text-white
                  px-8
                  md:px-10
                  py-3
                  rounded-full
                  font-bold
                  uppercase
                  tracking-wide
                  hover:bg-[#005f8d]
                  transition-all
                  shadow-lg
                  active:scale-95
                "
              >
                Login To Continue
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* <SubPageFooter /> */}
    </div>
  );
};

export default DesignWomen;